export const createPreferencesSlice = (set) => ({
    language: 'en',
    setLanguage: (language) => set({ language }),
});
//# sourceMappingURL=preferencesSlice.js.map